import * as React from "react";
import styles from "./Dashboard.module.css";
import { cn } from "@/utils/cn";
import { AppSidebar } from "../AppSidebar/AppSidebar";
import { SidebarProvider, SidebarTrigger } from "../Sidebar/Sidebar";
import logo from "@/assets/logo.webp";

const Dashboard = ({
  children,
  className,
  activePage,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  activePage?: string;
}) => {
  return (
    <SidebarProvider>
      <div className={styles.wrapper}>
        <AppSidebar activePage={activePage} />
        <main className={cn(styles.main, className)} {...props}>
          <div className={styles.mobileTopbar}>
            <SidebarTrigger />
            <img src={logo} style={{ width: "140px", height: "24.5px" }} />
          </div>
          <div className={styles.content}>{children}</div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export { Dashboard };
